<template>
  <div class="membership_manage_width">
    <v-stepper
      v-model="e1"
      alt-labels
      class="membership_manage_setting pb-0"
      :vertical="true"
    >
      <v-stepper-header style="font-size:0.9rem; background-color: #FCFCFC;">
        <v-stepper-step step="1" style="width:150px;" editable complete>
          <div style="font-size: 15px; line-height: 1.5;">
            <p :class="step1ClassTop">멤버십</p>
            <p :class="step1ClassBottom">상품/혜택 설정</p>
          </div>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          step="2"
          style="width:150px;"
          :editable="step2_editable"
          :complete="step2_complete"
        >
          <div style="font-size: 15px; line-height: 1.5;">
            <p :class="step2ClassTop">
              멤버십 상품페이지
            </p>
            <p :class="step2ClassBottom">화면 설정</p>
          </div>
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          step="3"
          :editable="step3_editable"
          :complete="step3_complete"
        >
          <div style="font-size: 15px; line-height: 1.5;">
            <p :class="step3ClassTop">멤버십 관리페이지</p>
            <p :class="step3ClassBottom">화면 설정</p>
          </div>
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <div v-if="e1 == 1" step="1" class="pa-0">
      <div>
        <MembershipReSetting ref="MembershipReSetting"></MembershipReSetting>
      </div>
    </div>

    <div v-else-if="e1 == 2" step="2" class="pa-0">
      <div>
        <MembershipDisplay ref="MembershipDisplay"></MembershipDisplay>
      </div>
    </div>

    <div v-else-if="e1 == 3" step="3" class="pa-0">
      <div>
        <MembershipManageDisplay
          ref="MembershipManageDisplay"
        ></MembershipManageDisplay>
      </div>
    </div>
  </div>
</template>
<script>
import M from "@/libs/mapping.js";

const MembershipReSetting = () =>
  import(
    /* webpackChunkName: "MembershipReStep" */ "@/components/membership/membership_manage/MembershipReSetting.vue"
  );
const MembershipDisplay = () =>
  import(
    /* webpackChunkName: "MembershipReStep" */ "@/components/membership/membership_manage/MembershipDisplay.vue"
  );
const MembershipManageDisplay = () =>
  import(
    /* webpackChunkName: "MembershipReStep" */ "@/components/membership/membership_manage/MembershipManageDisplay.vue"
  );

export default {
  data() {
    return {
      membership_id: 0,
      e1: 1,
      step2_editable: true,
      step2_complete: false,
      step3_complete: false,
      step3_editable: false,
      step1ClassTop: "mb-1 text-center",
      step1ClassBottom: "mb-0 text-center",
      step2ClassTop: "mb-1 text-center",
      step2ClassBottom: "mb-0 text-center",
      step3ClassTop: "mb-1 text-center",
      step3ClassBottom: "mb-0 text-center",
      commonClassTop: "mb-1 text-center",
      commonClassBottom: "mb-0 text-center",
    };
  },
  methods: {
    //멤버십 조회
    getMembershipInfo: async function() {
      try {
        let result = await M.api(
          M.entry("/get/membership/display", this.membership_id)
        );

        if (
          result.button_text &&
          result.product_detail_image &&
          result.product_image
        ) {
          this.step2_complete = true;
          this.step3_editable = true;
        } else {
          this.step3_editable = false;
        }
      } catch (e) {
        //console.log(e);
      }
    },
    getMembershipBenefitPage: async function(membership_id) {
      try {
        let result = await M.api(
          M.entry("/get/membership/benefits", membership_id)
        );
        if (
          result.membership_id &&
          result.benefit_title &&
          result.benefit_image &&
          result.benefits.length > 0
        ) {
          this.step3_complete = true;
        } else {
          this.step3_complete = false;
        }
      } catch (e) {
        //console.log(e);
      }
    },
  },
  components: {
    MembershipReSetting,
    MembershipDisplay,
    MembershipManageDisplay,
  },

  created: async function() {
    this.membership_id = this.$route.query.membership_id;
    if (this.$route.query.step) {
      this.e1 = this.$route.query.step;
    }

    await this.getMembershipInfo();
    await this.getMembershipBenefitPage(this.membership_id);

    if (this.e1 == 1) {
      this.step1ClassTop = "mb-1 text-center primary--text";
      this.step1ClassBottom = "mb-0 text-center primary--text";
    } else if (this.e1 == 2) {
      this.step2ClassTop = "mb-1 text-center primary--text";
      this.step2ClassBottom = "mb-0 text-center primary--text";
    } else if (this.e1 == 3) {
      this.step3ClassTop = "mb-1 text-center primary--text";
      this.step3ClassBottom = "mb-0 text-center primary--text";
    } else {
      //
    }
  },

  watch: {
    e1: function() {
      this.step1ClassTop = this.commonClassTop;
      this.step1ClassBottom = this.commonClassBottom;
      this.step2ClassTop = this.commonClassTop;
      this.step2ClassBottom = this.commonClassBottom;
      this.step3ClassTop = this.commonClassTop;
      this.step3ClassBottom = this.commonClassBottom;
      if (this.e1 == 1) {
        this.step1ClassTop = "mb-1 text-center primary--text";
        this.step1ClassBottom = "mb-0 text-center primary--text";
      } else if (this.e1 == 2) {
        this.step2ClassTop = "mb-1 text-center primary--text";
        this.step2ClassBottom = "mb-0 text-center primary--text";
      } else if (this.e1 == 3) {
        this.step3ClassTop = "mb-1 text-center primary--text";
        this.step3ClassBottom = "mb-0 text-center primary--text";
      } else {
        //
      }
    },
  },
};
</script>
